"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditorState = void 0;
var CreditorState;
(function (CreditorState) {
    CreditorState["Lead"] = "LEAD";
    CreditorState["SignedOn"] = "SIGNED_ON";
    CreditorState["Active"] = "ACTIVE";
    CreditorState["Cancelled"] = "CANCELLED";
    CreditorState["Ceased"] = "CEASED";
})(CreditorState || (exports.CreditorState = CreditorState = {}));
//# sourceMappingURL=index.js.map